import React from "react";

function Portfolio() {
  return (
    <section id="portfolio" className="portfolio">
      <div className="container">
        <div className="section-title">
          <h2>Portfolio</h2>
          <p>My Works</p>
        </div>

        <div className="row">
          <div className="col-lg-12 d-flex justify-content-center">
            <ul id="portfolio-flters">
              <li data-filter="*" className="filter-active">
                All
              </li>
              <li data-filter=".filter-phpLaravel">PHP & Laravel</li>
              <li data-filter=".filter-Net">.Net & C#</li>
              <li data-filter=".filter-react">React</li>
            </ul>
          </div>
        </div>

        <div className="row portfolio-container">
          <div className="col-lg-4 col-md-6 portfolio-item filter-Net">
            <div className="portfolio-wrap">
              <img
                src="assets/img/portfolio/WFM.png"
                className="img-fluid"
                alt="WFM"
              />
              <div className="portfolio-info">
                <h4>WFM System</h4>
                <p>System for WFM Construction company</p>
                <div className="portfolio-links">
                  {/* <a
                    href="https://awshad-phototime.netlify.app/"
                    target="_blank"
                  >
                    <i className="bx bx-link"></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>

          

          <div className="col-lg-4 col-md-6 portfolio-item filter-phpLaravel">
            <div className="portfolio-wrap">
              <img
                src="assets/img/portfolio/Thakshilawa.png"
                className="img-fluid"
                alt="Thakshilawa"
              />
              <div className="portfolio-info">
                <h4>Thakshilawa Institute Management System</h4>
                <p>Admin panel for Institute Management System</p>
                <div className="portfolio-links">
                  {/* <a
                    href="https://incometunnel.com/user/login.php"
                    target="_blank"
                  >
                    <i className="bx bx-link"></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-phpLaravel">
            <div className="portfolio-wrap">
              <img
                src="assets/img/portfolio/incometunnel-admin.png"
                className="img-fluid"
                alt="Income tunnel"
              />
              <div className="portfolio-info">
                <h4>Income Tunnel</h4>
                <p>Responsive Admin panel for Income Tunnel</p>
                <div className="portfolio-links">
                  {/* <a
                    href="https://incometunnel.com/user/login.php"
                    target="_blank"
                  >
                    <i className="bx bx-link"></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>


          <div className="col-lg-4 col-md-6 portfolio-item filter-Net">
            <div className="portfolio-wrap">
              <img
                src="assets/img/portfolio/HealthCare.png"
                className="img-fluid"
                alt="HealthCare"
              />
              <div className="portfolio-info">
                <h4>Health Care System</h4>
                <p>System for Health Care company</p>
                <div className="portfolio-links">
                  {/* <a
                    href="https://awshad-phototime.netlify.app/"
                    target="_blank"
                  >
                    <i className="bx bx-link"></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>
          

          <div className="col-lg-4 col-md-6 portfolio-item filter-phpLaravel">
            <div className="portfolio-wrap">
              <img
                src="assets/img/portfolio/DayDreams.png"
                className="img-fluid"
                alt="DayDreams"
              />
              <div className="portfolio-info">
                <h4>DayDreams</h4>
                <p>Online Cosmetics purchasing system for customers</p>
                <div className="portfolio-links">
                  {/* <a href="https://day-dreams.herokuapp.com/" target="_blank">
                    <i className="bx bx-link"></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-react">
            <div className="portfolio-wrap">
              <img
                src="assets/img/portfolio/netflix-clone.png"
                className="img-fluid"
                alt="To do app"
              />
              <div className="portfolio-info">
                <h4>Netflix clone</h4>
                <p>Netflix clone interface</p>
                <div className="portfolio-links">
                  {/* <a href="https://netflixclone-98c98.web.app/" target="_blank">
                    <i className="bx bx-link"></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-phpLaravel">
            <div className="portfolio-wrap">
              <img
                src="assets/img/portfolio/Help-Desk.png"
                className="img-fluid"
                alt="Help-Desk"
              />
              <div className="portfolio-info">
                <h4>Help Desk</h4>
                <p>Online Help Desk application</p>
                <div className="portfolio-links">
                  {/* <a href="https://day-dreams.herokuapp.com/" target="_blank">
                    <i className="bx bx-link"></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-phpLaravel">
            <div className="portfolio-wrap">
              <img
                src="assets/img/portfolio/eLMS.png"
                className="img-fluid"
                alt="eLMS"
              />
              <div className="portfolio-info">
                <h4>E-LMS System</h4>
                <p>Admin panel for ELMS</p>
                <div className="portfolio-links">
                  {/* <a
                    href="https://incometunnel.com/user/login.php"
                    target="_blank"
                  >
                    <i className="bx bx-link"></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-phpLaravel">
            <div className="portfolio-wrap">
              <img
                src="assets/img/portfolio/LRC.png"
                className="img-fluid"
                alt="LRC"
              />
              <div className="portfolio-info">
                <h4>Learning Resource Centere</h4>
                <p>Online results system</p>
                <br />
                <p>
                  ID for Grade 8: <b>LRC/2022/011</b>
                </p>
                <p>
                  ID for Grade 10: <b>LRC/2022/01</b>
                </p>
                <div className="portfolio-links">
                  {/* <a href="https://lrc-results.herokuapp.com/" target="_blank">
                    <i className="bx bx-link"></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-phpLaravel">
            <div className="portfolio-wrap">
              <img
                src="assets/img/portfolio/LRC-admin.png"
                className="img-fluid"
                alt="LRC"
              />
              <div className="portfolio-info">
                <h4>Learning Resource Centere</h4>
                <p>Online results system admin panel</p>
                <div className="portfolio-links">
                  {/* <a
                    href="https://lrc-results.herokuapp.com/login.php"
                    target="_blank"
                  >
                    <i className="bx bx-link"></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-phpLaravel">
            <div className="portfolio-wrap">
              <img
                src="assets/img/portfolio/incometunnel.png"
                className="img-fluid"
                alt="Income tunnel"
              />
              <div className="portfolio-info">
                <h4>Income Tunnel</h4>
                <p>Responsive Website for Income Tunnel</p>
                <div className="portfolio-links">
                  {/* <a href="http://incometunnel.com/" target="_blank">
                    <i className="bx bx-link"></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-phpLaravel">
            <div className="portfolio-wrap">
              <img
                src="assets/img/portfolio/Voting-app.png"
                className="img-fluid"
                alt="Voting app"
              />
              <div className="portfolio-info">
                <h4>Voting app</h4>
                <p>Online Election Voting Application</p>
                <div className="portfolio-links">
                  {/* <a href="http://incometunnel.com/" target="_blank">
                    <i className="bx bx-link"></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-phpLaravel">
            <div className="portfolio-wrap">
              <img
                src="assets/img/portfolio/wtd-customer.jpg"
                className="img-fluid"
                alt="WTD"
              />
              <div className="portfolio-info">
                <h4>WTD Restaurant</h4>
                <p>
                  Online food ordering & table reservation platform for
                  customers
                </p>
                <div className="portfolio-links">
                  {/* <a href="/WTD_Doc.pdf" target="_blank">
                    <i className="bx bx-link"></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>

          

          <div className="col-lg-4 col-md-6 portfolio-item filter-phpLaravel">
            <div className="portfolio-wrap">
              <img
                src="assets/img/portfolio/POS.png"
                className="img-fluid"
                alt="POS"
              />
              <div className="portfolio-info">
                <h4>POS</h4>
                <p>Online POS system for shops</p>
                <div className="portfolio-links">
                  {/* <a href="https://day-dreams.herokuapp.com/" target="_blank">
                    <i className="bx bx-link"></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-react">
            <div className="portfolio-wrap">
              <img
                src="assets/img/portfolio/to-do-app.jpg"
                className="img-fluid"
                alt="To do app"
              />
              <div className="portfolio-info">
                <h4>To do app</h4>
                <p>To do list application</p>
                <div className="portfolio-links">
                  {/* <a
                    href="https://awshad-to-do-app.netlify.app/"
                    target="_blank"
                  >
                    <i className="bx bx-link"></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-phpLaravel">
            <div className="portfolio-wrap">
              <img
                src="assets/img/portfolio/DayDreams-admin1.png"
                className="img-fluid"
                alt="DayDreams"
              />
              <div className="portfolio-info">
                <h4>DayDreams</h4>
                <p>Online Cosmetics purchasing system admin panel</p>
                <div className="portfolio-links">
                  {/* <a
                    href="https://day-dreams.herokuapp.com/admin"
                    target="_blank"
                  >
                    <i className="bx bx-link"></i>
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
